// @ts-nocheck
import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InjectableMaskCnj } from '../../../../../helpers/_old_helpers/masks/cnj';
import { BASE_SERVICE } from '../../../../../services/base.service';
import { LoadingComponent } from '../../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../../body-feedback/body-feedback.component';
import { SearchBoxComponent } from '../../../search-box/search-box.component';
import { TableComponent } from '../../../table/table.component';
import { Table } from '../../../table/table.model';
import { FormTemplateService } from '../form-template/form-template.service';
import { QueryStringParameters, tableHeader } from './search-table';

@Component({
  selector: 'lbca-search-module',
  templateUrl: './search-module.component.html',
  styleUrl: './search-module.component.scss',
  imports: [SearchBoxComponent, LoadingComponent, BodyFeedbackComponent, TableComponent],
})
export class SearchModuleComponent implements OnInit {
  private processId;
  public queryOptions;
  public loadPage = false;
  private flowIds;
  public clearSearchFunctionEs = null;
  public params;
  public tag;
  public url;
  public tagList: string[] = [];
  public disabled;
  public feedback = false;

  @ViewChild('currentStatus', { static: true }) currentStatus!: ElementRef;

  @Input('properties') set configuration(properties) {
    if (properties.configuration.search) {
      this.tag = properties?.configuration?.search?.tag ?? null;
      this.feedback = true;
    }
    this.params = properties.configuration.people?.params;
    this.url = properties.configuration.people?.url;
  }
  @Input()
  set cardData(data: any) {
    this.processId = data.processId;
  }
  @Input('origin') set disable(value) {
    if (value === 'task-form-complete') {
      this.disabled = true;
    }
  }
  public table: Table = {
    columns: [],
    body: [],
  };

  readonly baseService = inject(BASE_SERVICE);

  constructor(
    private router: Router,
    private formTemplateService: FormTemplateService,
    private maskCnj: InjectableMaskCnj
  ) {}

  ngOnInit() {
    this.getContextByUserIdAndCapability();
    this.baseService.getSearchTags().subscribe((resp) => {
      this.queryOptions = resp;
    });

    if (!this.processId) {
      this.loadPage = true;
      return;
    }

    this.baseService.getOneProcess(this.processId).subscribe((resp) => {
      const process = resp?.[0];
      const processNumberLocal = process.processNumber || process.process_number;

      if (this.tag) {
        this.tag.value = processNumberLocal ? processNumberLocal : process.cnj;
        this.tagList.push(this.tag);
        this.search(this.table, this.getSearchParams(this.tagList));
      }
      this.loadPage = true;
    });
  }

  getSearchParams(tagList) {
    const userId = localStorage.getItem('user-id');
    const commonSearchList = tagList.filter((tag) => tag.key.includes('_general', 0));
    commonSearchList.forEach((element) => {
      if (element.value.toLowerCase().includes('aberto')) {
        element.value = 'open';
      }
      if (
        element.value.toLowerCase().includes('fechado') ||
        element.value.toLowerCase().includes('concluido') ||
        element.value.toLowerCase().includes('finalizado')
      ) {
        element.value = 'finished';
      }
    });
    const commonSearchValue = commonSearchList.map((tag) => tag.value);
    const extraFields = tagList.filter((tag) => !tag.key.includes('_general', 0));
    if (commonSearchValue?.length) {
      Object.keys(commonSearchValue).forEach((searchValue) => {
        const search = {
          value: commonSearchValue[searchValue],
          type: 'general',
          key: searchValue + '_general',
          label: 'geral',
        };
        extraFields.push(search);
      });
    }

    const preRegisterState = {
      value: 'canceled',
      type: 'string',
      key: 'preRegisterState',
      must_not: true,
    };
    extraFields.push(preRegisterState);

    const processIdSearch = {
      value: this.processId,
      type: 'string',
      key: 'id',
      ignore: true,
    };
    extraFields.push(processIdSearch);

    const queryStringParameters: QueryStringParameters = {
      idx: 'process',
      returnFields: JSON.stringify(['*']),
      sourceFields: JSON.stringify(['*']),
      page: 0,
      size: '10',
      sort: JSON.stringify(['id.keyword']),
      extraFields: JSON.stringify(extraFields),
      capabilityName: 'base/home',
    };

    return queryStringParameters;
  }

  search(table: Table, queryStringParameters: QueryStringParameters) {
    this.feedback = true;
    this.baseService
      .getSearchList(queryStringParameters as unknown as Record<string, string | string[]>)
      .subscribe((body: any) => {
        this.loadPage = true;
        tableHeader.forEach((item) => {
          if (item.name === 'status') item.templateRef = this.currentStatus;
        });

        table.columns = tableHeader;
        body.data.forEach((element) => {
          element.status = element.preRegisterState || element.status;
          if (element.requesting_authorities) {
            this.params.ids = `["${element.requesting_authorities.primary}"]`;
            this.formTemplateService
              .getDinamicUrl<Array<any>>(this.url, this.params)
              .subscribe((people: Array<any>) => {
                element.requestingAuthorities = people[0].name;
              });
          }
          const processNumberLocal = element.processNumber || element.process_number;
          if (element.cnj) {
            const value = this.maskCnj.setMask(element.cnj, 0);
            element.cnjOrProcessNumber = value?.formatedValue;
          } else if (processNumberLocal) {
            element.cnjOrProcessNumber = processNumberLocal;
          }

          table.body = body.data;
        });
      });
    this.loadPage = false;
  }
  public async getContextByUserIdAndCapability() {
    const userId = localStorage.getItem('user-id');
    const params = {
      userId: userId ?? '',
      capabilityName: 'base/home',
    };
    this.baseService.getContextByuserIdAndCapability(params).subscribe((resp: any) => {
      this.flowIds = resp;
    });
  }
  public clearSearchValue() {
    this.loadPage = true;
    this.feedback = false;
    this.table.body = [];
    this.table.columns = [];
  }

  public clearSearchFunction($event) {
    this.clearSearchFunctionEs = $event;
  }

  public clickLine($event): void {
    this.router.navigate([]).then((result) => {
      window.open('/base/form/' + $event.id, '_blank');
    });
  }

  setSearchValue(tagList) {
    this.search(this.table, this.getSearchParams(tagList));
  }
}
